import { createSelector } from 'reselect'
import { getCandidateProfile } from '../reducks/profile'

export const candidateProfileDetails = createSelector([getCandidateProfile], profile => ({
  id: profile.id,
  areaOfWork: profile.primary_role,
  currentState: profile.current_state,
  isInZaRegion: profile.region_code === 'za',
}))

export const canViewJobSearchData = createSelector([getCandidateProfile], ({ current_state }) => {
  return ['in_review', 'accepted', 'ready_to_go_live', 'live', 'post_live'].includes(current_state)
})

export const enabledForCurrentState = createSelector([getCandidateProfile], ({ current_state }) => {
  if (current_state) {
    return !['live', 'post_live'].includes(current_state)
  }
  return false
})

export const getCandidateProfileId = createSelector([getCandidateProfile], ({ id }) => id)

export const isCandidateProfileInitialised = createSelector([getCandidateProfile], ({ id }) => Boolean(id))
